const appConfig = {
  awsProjectRegion: "eu-central-1",//Region
  awsCognitoIdentityPoolId: "eu-central-1:13b3073a-1ffe-4504-bce5-8c9fb6f8f4ec",// Identity Pool Id from cognito
  awsCognitoRegion: "eu-central-1",//Region
  awsUserPoolsId: "eu-central-1_xdGFMuzQO",// User Pool Id from Cognito
  awsUserPoolsWebClientId: "16bl74ipun7832sjl744o9lcg8", //ClientId from cognito
  awsCognitoDomain: "eu-central-1xdgfmuzqo.auth.eu-central-1.amazoncognito.com",// Domain from Cognito
  awsHVACIDP: "hvacqaextcarrier",//Hvac IDP
  awsIDP: "CCREntraID",//CCR IDP
  storageUri: 'https://staticfilesappshub.ccr.com/',//Storage base Api
  api: {
    development: 'https://api-appshub.ccr.com',// UM APi url //this is appshub.ccr.com
  },
  ui: {
    development: 'https://appshub.ccr.com'// UM App url
  }
};

export default appConfig;